import React, { useEffect, useState } from "react";
import { useTranslation, Trans } from "react-i18next";
import cx from "classnames";

// import ZmtRoadmapLaunchMobile from "./animations/zmt-roadmap-launch-mobile";
// import ZmtRoadmapQ1Mobile from "./animations/zmt-roadmap-q1-mobile";
// import ZmtRoadmapQ2Mobile from "./animations/zmt-roadmap-q2-mobile";

import { gsap } from "gsap";
//import {Waypoint} from 'react-waypoint';
//import TokenDistribution from "./animations/token-distribution";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default function ZmtRoadmapMobile(props) {
  const { t } = useTranslation();

  const [isHidden, setIsHidden] = useState(true);
  useEffect(() => {
    if (typeof window !== `undefined`) {
      gsap.registerPlugin(ScrollTrigger);
      gsap.core.globals("ScrollTrigger", ScrollTrigger);
    }

    let scrollId = null;
    const scrolls = [];

    gsap.utils
      .toArray(".roadmap-mobile .row.roadmap-section")
      .forEach(function (elem) {
        //console.log(elem);

        const lines = elem.querySelectorAll(".roadmap-line-vertical");
        const titles = elem.querySelectorAll(".single-date span");

        gsap
          .timeline({
            scrollTrigger: {
              id: "roadmapTrigger",
              //markers: true,
              trigger: elem,
              start: "top center",
              toggleActions: "play none none reverse",
            },
          })

          .from(
            lines,
            {
              borderColor: "#a8b2bd",
              opacity: 0.16,
              duration: 1,
              ease: "linear",
            },
            0
          )
          .to(lines, { borderColor: "#21bdca", opacity: 1, ease: "linear" })
          .from(titles, { duration: 1, ease: "linear", color: "#a8b2bd" }, 0)
          .to(titles, { color: "#21bdca" });

        scrollId = ScrollTrigger.getById("roadmapTrigger");
        scrolls.push(scrollId);

        //console.log(scrollId);

        ScrollTrigger.matchMedia({
          // desktop
          "(max-width: 767px)": function () {
            // setup animations and ScrollTriggers for screens 800px wide or greater (desktop) here...
            // These ScrollTriggers will be reverted/killed when the media query doesn't match anymore.
            // a loop for the other sections '.section'
            scrolls.forEach(function (scroll) {
              scroll.enable();
            });
          },
          // mobile
          "(min-width: 768px)": function () {
            scrolls.forEach(function (scroll) {
              scroll.disable();
            });
          },
          // all
          all: function () {
            // ScrollTriggers created here aren't associated with a particular media query,
            // so they persist.
          },
        });
        ScrollTrigger.refresh();
      });
  }, []);

  useEffect(() => {
    ScrollTrigger.refresh();
  }, [isHidden]);

  return (
    <>
      <div className="col-12 d-block d-md-none roadmap-mobile">
        <div className="row roadmap-section">
          <div className="col-1">
            <img
              src={props.iconPointer3.publicURL}
              className="mr-3 ml-2"
              alt="ZMT Roadmap"
            />
            <div className="roadmap-line-vertical"></div>
          </div>
          <div className="col-11">
            <h2>
              <Trans i18nKey="zmt.roadmap.title" components={[<>Roadmap</>]} />
            </h2>
          </div>
        </div>

        <div className="row pt-3 roadmap-section">
          <div className="col-1">
            <img
              src={props.iconPointer2.publicURL}
              className="mr-3"
              alt="Listed on Zipmex Exchange"
            />
            <div className="roadmap-line-vertical"></div>
          </div>
          <div className="col-11">
            <div className="card-roadmap">
              <div className="single-date">
                <span>{t("zmt.roadmap.road.0.date")}</span>
              </div>
              <div className="card-roadmap-inner">
                <div className={cx("card-roadmap__line", `q0`)} />
                <ul className="list-unstyled">
                  <li className="media">
                    <img
                      src={props.iconPointer.publicURL}
                      className="mr-3"
                      alt={t("zmt.roadmap.road.0.maps.0")}
                    />
                    <div className="media-body">
                      <h5 className="mt-0 mb-1">
                        {t("zmt.roadmap.road.0.maps.0")}
                      </h5>
                    </div>
                  </li>
                  <li className="media my-4">
                    <img
                      src={props.iconPointer.publicURL}
                      className="mr-3"
                      alt={t("zmt.roadmap.road.0.maps.1")}
                    />
                    <div className="media-body">
                      <h5 className="mt-0 mb-1">
                        {t("zmt.roadmap.road.0.maps.1")}
                      </h5>
                    </div>
                  </li>
                  <li className="media">
                    <img
                      src={props.iconPointer.publicURL}
                      className="mr-3"
                      alt={t("zmt.roadmap.road.0.maps.2")}
                    />
                    <div className="media-body">
                      <h5 className="mt-0 mb-1">
                        {t("zmt.roadmap.road.0.maps.2")}
                      </h5>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="row pt-3 roadmap-section">
          <div className="col-1">
            <img
              src={props.iconPointer2.publicURL}
              className="mr-3"
              alt="Listed on Zipmex Exchange"
            />
            <div className="roadmap-line-vertical"></div>
          </div>
          <div className="col-11">
            <div className="card-roadmap">
              <div className="single-date">
                <span>{t("zmt.roadmap.road.1.date")}</span>
              </div>
              <div className="card-roadmap-inner">
                <div className={cx("card-roadmap__line", `q1`)} />
                <ul className="list-unstyled">
                  <li className="media">
                    <img
                      src={props.iconPointer.publicURL}
                      className="mr-3"
                      alt={t("zmt.roadmap.road.1.maps.0")}
                    />
                    <div className="media-body">
                      <h5 className="mt-0 mb-1">
                        {t("zmt.roadmap.road.1.maps.0")}
                      </h5>
                    </div>
                  </li>
                  <li className="media my-4">
                    <img
                      src={props.iconPointer.publicURL}
                      className="mr-3"
                      alt={t("zmt.roadmap.road.1.maps.1")}
                    />
                    <div className="media-body">
                      <h5 className="mt-0 mb-1">
                        {t("zmt.roadmap.road.1.maps.1")}
                      </h5>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className={isHidden ? "d-none" : ""}>
          <div className="row pt-3 roadmap-section">
            <div className="col-1">
              <img
                src={props.iconPointer2.publicURL}
                className="mr-3"
                alt="ZMT Roadmap"
              />
              <div className="roadmap-line-vertical"></div>
            </div>
            <div className="col-11">
              <div className="card-roadmap">
                <div className="single-date">
                  <span>{t("zmt.roadmap.road.2.date")}</span>
                </div>
                <div className="card-roadmap-inner">
                  <div className={cx("card-roadmap__line", `q2`)} />
                  <ul className="list-unstyled">
                    <li className="media">
                      <img
                        src={props.iconPointer.publicURL}
                        className="mr-3"
                        alt={t("zmt.roadmap.road.2.maps.0")}
                      />
                      <div className="media-body">
                        <h5 className="mt-0 mb-1">
                          {t("zmt.roadmap.road.2.maps.0")}
                        </h5>
                      </div>
                    </li>
                    <li className="media my-4">
                      <img
                        src={props.iconPointer.publicURL}
                        className="mr-3"
                        alt={t("zmt.roadmap.road.2.maps.1")}
                      />
                      <div className="media-body">
                        <h5 className="mt-0 mb-1">
                          {t("zmt.roadmap.road.2.maps.1")}
                        </h5>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="row pt-3 roadmap-section">
            <div className="col-1">
              <img
                src={props.iconPointer2.publicURL}
                className="mr-3"
                alt="ZMT Roadmap"
              />
              <div className="roadmap-line-vertical"></div>
            </div>
            <div className="col-11">
              <div className="card-roadmap">
                <div className="single-date">
                  <span>{t("zmt.roadmap.road.3.date")}</span>
                </div>
                <div className="card-roadmap-inner">
                  <div className={cx("card-roadmap__line", `q3`)} />
                  <ul className="list-unstyled">
                    {t("zmt.roadmap.road.3.maps", { returnObjects: true }).map(
                      (roadmap, i) => (
                        <li className={cx("media", { "mt-4": i > 0 })}>
                          <img
                            src={props.iconPointer.publicURL}
                            className="mr-3"
                            alt=""
                          />
                          <div className="media-body">
                            <h5 className="mt-0 mb-1">{roadmap}</h5>
                          </div>
                        </li>
                      )
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="row pt-3 roadmap-section">
            <div className="col-1">
              <img
                src={props.iconPointer2.publicURL}
                className="mr-3"
                alt="ZMT Roadmap"
              />
              <div className="roadmap-line-vertical"></div>
            </div>
            <div className="col-11">
              <div className="card-roadmap">
                <div className="single-date">
                  <span>{t("zmt.roadmap.road.4.date")}</span>
                </div>
                <div className="card-roadmap-inner">
                  <div className={cx("card-roadmap__line", `q4`)} />
                  <ul className="list-unstyled">
                    <li className="media">
                      <img
                        src={props.iconPointer.publicURL}
                        className="mr-3"
                        alt={t("zmt.roadmap.road.4.maps.0")}
                      />
                      <div className="media-body">
                        <h5 className="mt-0 mb-1">
                          {t("zmt.roadmap.road.4.maps.0")}
                        </h5>
                      </div>
                    </li>
                    <li className="media my-4">
                      <img
                        src={props.iconPointer.publicURL}
                        className="mr-3"
                        alt={t("zmt.roadmap.road.4.maps.1")}
                      />
                      <div className="media-body">
                        <h5 className="mt-0 mb-1">
                          {t("zmt.roadmap.road.4.maps.1")}
                        </h5>
                      </div>
                    </li>
                    <li className="media my-4">
                      <img
                        src={props.iconPointer.publicURL}
                        className="mr-3"
                        alt={t("zmt.roadmap.road.4.maps.2")}
                      />
                      <div className="media-body">
                        <h5 className="mt-0 mb-1">
                          {t("zmt.roadmap.road.4.maps.2")}
                        </h5>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={!isHidden ? "d-none" : "row justify-content-center mt-5"}
        >
          <p>
            <button
              onClick={() => {
                setIsHidden(false);
              }}
              className="button button-secondary button-buy"
            >
              {t("zmt.roadmap.btnShowMore")}
            </button>
          </p>
        </div>
      </div>
    </>
  );
}
